var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"daq-button",class:['daq-button-' + _vm.type,'daq-button-' + _vm.size, _vm.disabled ? 'daq-button-disabled' : '',_vm.isRound ? 'daq-button-round' : '' ],on:{"click":_vm.change}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4927b846","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/button.vue
// module id = null
// module chunks = 